import { render, staticRenderFns } from "./CheckboxTable.vue?vue&type=template&id=85c15736&scoped=true"
import script from "./CheckboxTable.vue?vue&type=script&lang=js"
export * from "./CheckboxTable.vue?vue&type=script&lang=js"
import style0 from "./CheckboxTable.vue?vue&type=style&index=0&id=85c15736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c15736",
  null
  
)

export default component.exports